export enum SnackbarType {
  SUCCESS = "good",
  WARNING = "warn",
  ERROR = "error",
}

export enum SnackbarPosition {
  TOP = "top",
  BOTTOM = "bottom",
}